import { ReactElement, useState } from 'react';
import DatePicker from 'react-datepicker';
import Lang from '@lang/en';
import { NullableString } from '../../common/types';
import {
  CalendarContainer,
  CalendarIconContainer,
  DateContainer,
} from './styles';
import { onDateChangeType } from './types';
import CalendarReactiveIcon from './calendarReactiveIcon';
import { datepickerDateFormats } from '@app/utils';

interface Props {
  onDateChange: onDateChangeType;
  value: NullableString;
  minDate?: string | number | null;
  maxDate?: string | number | null;
  disabled?: boolean;
  selectsEnd?: boolean;
  inputWidth?: number;
  className?: string;
  'data-testid'?: string;
  errorMessage?: boolean;
}

const ExactDateFilter = ({
  onDateChange,
  value,
  minDate,
  maxDate,
  disabled,
  selectsEnd,
  inputWidth,
  className,
  errorMessage,
  ...restProps
}: Props): ReactElement => {
  const [active, setActive] = useState(false);
  const dataTest = restProps['data-testid'] || 'common-dateFilter';

  const handleOnBlur = () => {
    if (typeof value === 'string' && !value?.trim().length) {
      onDateChange(new Date());
    }
  };

  return (
    <DateContainer
      className={className}
      inputWidth={inputWidth}
      active={active}
      disabled={disabled}
      errorMessage={errorMessage}
    >
      <CalendarContainer className="datePicker" data-testid={dataTest}>
        <DatePicker
          onBlur={handleOnBlur}
          onChange={(value) =>
            onDateChange(Array.isArray(value) ? value[0] : value)
          }
          selected={value ? new Date(value) : null}
          minDate={minDate ? new Date(minDate) : null}
          maxDate={maxDate ? new Date(maxDate) : null}
          startDate={minDate ? new Date(minDate) : null}
          placeholderText={Lang.chooseDatePlaceholder}
          calendarStartDay={1}
          selectsEnd={selectsEnd}
          disabled={disabled}
          onCalendarOpen={() => setActive(true)}
          onCalendarClose={() => setActive(false)}
          dateFormat={datepickerDateFormats[0]}
          popperPlacement="bottom-end"
        />
        <CalendarIconContainer>
          <CalendarReactiveIcon value={value} />
        </CalendarIconContainer>
      </CalendarContainer>
    </DateContainer>
  );
};

export default ExactDateFilter;
